import { render, staticRenderFns } from "./ItemAdmin.vue?vue&type=template&id=151715e7&scoped=true&"
import script from "./ItemAdmin.vue?vue&type=script&lang=js&"
export * from "./ItemAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdmin.vue?vue&type=style&index=0&id=151715e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151715e7",
  null
  
)

export default component.exports